import { memo } from 'react';
import { VStack, Heading, TextBlock } from '@library';
import CurrentStoreLink from '../../../core/components/router/CurrentStoreLink';
import type { ProductWithRelatedData } from '../../types';
import styles from './ProductStocklistViewDescription.module.scss';

const ProductStocklistViewDescription = ({
    product,
    productDetailsLink,
}: {
    product: ProductWithRelatedData;
    productDetailsLink: string;
}) => {
    const { manufacturer, name, siblingAttributes } = product;

    return (
        <VStack>
            <div className={styles.brand}>
                <TextBlock
                    tertiary
                    medium
                    uppercase
                    letterSpacing="small"
                    center
                    lineHeightAsFontSize
                >
                    {manufacturer}
                </TextBlock>
            </div>

            <VStack gap="micro">
                <CurrentStoreLink
                    className={styles.name}
                    data-test-class="productDetailsLink"
                    to={productDetailsLink}
                >
                    <Heading h6 center>
                        {name}
                    </Heading>
                </CurrentStoreLink>
                <TextBlock caption center regular>
                    {siblingAttributes && siblingAttributes.length > 0 ? (
                        siblingAttributes[0].value
                    ) : (
                        <span />
                    )}
                </TextBlock>
            </VStack>
        </VStack>
    );
};

export default memo(ProductStocklistViewDescription);
